import { Theme, get } from "theme-ui";
import { border } from "./util";
import { lighten } from "@theme-ui/color";

export const forms: Theme["forms"] = {
  label: {
    variant: "styles.bodyLarge",
    fontSize: 3
  },
  input: {
    borderRadius: 0,
    padding: 0,
    backgroundColor: "surface.muted",
    ...border({ borderColor: "transparent" }),
    outlineWidth: "4px",
    outlineColor: "transparent",
    outlineStyle: "solid",
    ":focus-visible": {
      outlineColor: "focus.default"
    },
    ":disabled": {
      opacity: 0.3
    },
    "::placeholder": {
      color: "text.subtle"
    },
    height: "40px",
    textIndent: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingRight: "35px"
  },
  dummy: {
    variant: "forms.input",
    "::placeholder": {
      color: "text.default"
    },
    ":focus::placeholder": {
      color: "transparent"
    }
  },
  error: {
    variant: "forms.input",
    borderColor: "semantic.error",
    ":focus-visible": {
      outlineColor: lighten("semantic.error", 0.2)
    }
  },
  search: {
    variant: "forms.input",
    borderRadius: 1,
    borderColor: "transparent",
    backgroundColor: "surface.muted",
    borderWidth: "1px",
    height: "34px",
    textIndent: "40px",
    paddingRight: "30px",
    ":focus-visible": {
      outline: "none",
      borderColor: "focus.muted"
    },
    "::placeholder": {
      fontWeight: (theme) => get(theme, "styles.bodyMedium.fontWeight"),
      fontSize: (theme) => get(theme, "styles.bodyMedium.fontSize"),
      color: (theme) => get(theme, "colors.text.default")
    }
  },
  searchModal: {
    variant: "forms.search",
    height: "80px",
    borderRadius: "unset",
    border: "none",
    backgroundColor: "surface.highlight",
    textIndent: "12px",
    fontSize: (theme) => get(theme, "styles.headerSmall.fontSize"),
    "::placeholder": {
      fontWeight: (theme) => get(theme, "styles.headerSmall.fontWeight"),
      fontSize: (theme) => get(theme, "styles.headerSmall.fontSize"),
      color: (theme) => get(theme, "colors.text.subtle")
    }
  },
  select: {
    variant: "forms.input",
    height: "24px",
    backgroundColor: "surface.highlight",
    borderRadius: "4px",
    borderColor: "borders.default",
    borderWidth: "1px",
    textIndent: "8px",
    color: "text.subtle",
    cursor: "pointer",

    ":focus, :focus-within, :focus-visible": {
      outlineColor: "focus.default",
      outlineWidth: "2px",
      outlineStyle: "solid"
    }
  },
  switch: {
    "input ~ &": {
      backgroundColor: "icons.default"
    },
    "input:checked ~ &": {
      backgroundColor: "semantic.enabled"
    }
  },
  radio: {}
};
